import * as React from "react";
import { IconButton, styled } from "@mui/material";
import { useCallback, useState } from "react";
import { useClinicState } from "../../../clinic/clinicStateContext";
import CreateIcon from "@mui/icons-material/Create";
import { RenameClinicDialog } from "./renameClinicDialog";

//region [[ Styles ]]

const ClinicNameMenu = styled("div")({
  padding: "12px 28px",
  textAlign: "center",
  background: "#E4E2ED",
  color: "#232323",
  borderRadius: "8px",
  border: "1px solid #232323",
  flex: 1,
  "&.master": {
    color: "#FFFFFF",
    background: "#4247C9",
    border: "none",
  },
});

const EditNameButton = styled(IconButton)({
  width: "18px",
  height: "18px",
  "& svg": {
    fill: "#8884A3",
    width: "12px",
    height: "12px",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicsSelectionMenuProps {
  onClinicSelect: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicNameBox = ({ ...props }: ClinicsSelectionMenuProps) => {
  const [
    {
      isMasterClinic,
      clinicData: { name: clinicWebName, displayName, id },
    },
  ] = useClinicState();

  const [isRenamingDialogOpen, setIsRenamingDialogOpen] = useState(false);

  const openRenameDialog = useCallback((e) => {
    e.stopPropagation();
    setIsRenamingDialogOpen(true);
  }, []);

  const handleClinicRenamed = useCallback(() => {
    // Shitty workaround. todo: reload the clinic!
    window.location.reload();
  }, []);

  return (
    <>
      <ClinicNameMenu
        onClick={props.onClinicSelect}
        className={isMasterClinic ? "master" : ""}
      >
        {displayName || clinicWebName}{" "}
        <EditNameButton onClick={openRenameDialog}>
          <CreateIcon />
        </EditNameButton>
      </ClinicNameMenu>
      <RenameClinicDialog
        clinicId={id}
        open={isRenamingDialogOpen}
        onClose={() => setIsRenamingDialogOpen(false)}
        onSubmit={handleClinicRenamed}
        initialDisplayName={displayName}
        initialUrlName={clinicWebName}
        label={"Rename"}
        inline={false}
      />
    </>
  );
};
